module.exports = __webpack_public_path__ + "static/img/word01.f2f34183.png";